import React from "react";

const RecetasPaciente = ({ recetas = [], consultas = [], onVerReceta }) => {
  const recetasArray = Array.isArray(recetas) ? recetas : [];
  const consultasArray = Array.isArray(consultas) ? consultas : [];

  if (recetasArray.length === 0) {
    return <div className="recetas-empty">No hay recetas registradas</div>;
  }

  const getFecha = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;

  d.setHours(d.getHours() + 6);
  return d;
};

  const formatFechaHora = (value) => {
    const d = getFecha(value);
    if (!d) return "—";
    return d.toLocaleString("es-MX", {
      day: "2-digit",
      month: "long",
      year: "numeric",

    });
  };

  // ============================
  // 1) NUMERACIÓN DE CONSULTAS (CONSISTENTE)
  // Consulta 1 = historia clínica inicial
  // Consulta 2+ = seguimientos ordenados por fecha ASC
  // ============================

  // Orden ASC para numerar seguimientos
  const seguimientosOrdenadosAsc = [...consultasArray].sort((a, b) => {
    const fa = getFecha(a?.fechaConsulta || a?.fecha_consulta || a?.creado_en) || new Date(0);
    const fb = getFecha(b?.fechaConsulta || b?.fecha_consulta || b?.creado_en) || new Date(0);
    return fa - fb;
  });

  const consultaNumeroById = {};
  const consultaFechaById = {};

  seguimientosOrdenadosAsc.forEach((c, idx) => {
    const id = c?.id ?? c?.uuid;
    if (id == null) return;
    consultaNumeroById[String(id)] = idx + 2; // Consulta 2,3,4...
    consultaFechaById[String(id)] =
      c?.fechaConsulta || c?.fecha_consulta || c?.creado_en || null;
  });

  // ============================
  // 2) ORDEN DE RECETAS (MÁS RECIENTE -> MÁS ANTIGUA)
  // Receta 1 = más reciente
  // ============================

  const getFechaReceta = (r) =>
    r?.fecha ||
    r?.fecha_emision ||
    r?.fecha_creacion ||
    r?.creado_en ||
    r?.created_at ||
    null;

  const recetasOrdenadas = [...recetasArray].sort((a, b) => {
    const fa = getFecha(getFechaReceta(a)) || new Date(0);
    const fb = getFecha(getFechaReceta(b)) || new Date(0);
    return fb - fa;
  });

  // ============================
  // 3) RESOLVER ASOCIACIÓN A CONSULTA / HISTORIA / INDEP
  // ============================

  const getConsultaIdFromReceta = (r) => {
    if (!r) return null;
    // Puede venir como objeto o ID o distintos nombres
    if (r.consulta && typeof r.consulta === "object") return r.consulta.id ?? r.consulta.uuid ?? null;
    return r.consulta ?? r.consulta_id ?? r.consultaId ?? null;
  };

  const getHistoriaIdFromReceta = (r) => {
    if (!r) return null;
    if (r.historia_clinica && typeof r.historia_clinica === "object")
      return r.historia_clinica.id ?? r.historia_clinica.uuid ?? null;
    return r.historia_clinica ?? r.historia_clinica_id ?? r.historiaClinica ?? null;
  };

  const getDiagnostico = (r) =>
    r?.diagnostico ||
    r?.diagnostico_snapshot ||
    r?.diagnosticoSnapshot ||
    "No registrado";

  const getShortConsultaOrHistoriaId = (r) => {
    const consultaId = getConsultaIdFromReceta(r);
    if (consultaId) {
        return String(consultaId).slice(-5).toUpperCase();
    }

    const historiaIdReceta = getHistoriaIdFromReceta(r);
    if (historiaIdReceta) {
        return String(historiaIdReceta).slice(-5).toUpperCase();
    }

    return null;
    };

  

  // ============================
  // RENDER
  // ============================

  return (
    <div className="recetas-lista">
      {recetasOrdenadas.map((receta, idx) => {
        const idReceta = receta?.id || receta?.uuid;
        const fechaReceta = getFechaReceta(receta);

        return (
          <div key={idReceta || `receta-${idx}`} className="receta-card">
            <div className="receta-header">
              <div className="receta-titulo">
                Receta {idx + 1}
              </div>
              <div className="receta-fecha">
                Fecha: {formatFechaHora(fechaReceta)}
              </div>
            </div>

            <div className="receta-body">
              <div className="receta-linea">
                <strong>Diagnóstico:</strong> {getDiagnostico(receta)}
              </div>
            
            {getShortConsultaOrHistoriaId(receta) && (
            <div className="receta-linea receta-consulta-id">
                <span>
                ID de la consulta {getShortConsultaOrHistoriaId(receta)}
                </span>
            </div>
            )}
            </div>

            <div className="receta-footer">
              <button className="btn-ver-receta" onClick={() => onVerReceta(receta)}>
                Ver
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RecetasPaciente;
